import { useTranslation } from 'react-i18next'
import { FullscreenModal } from '@/components/global/FullscreenModal/FullscreenModal'
import { Button } from '@/components/priority/Button/Button'
import { Flex } from '@/components/priority/Flex/Flex'
import { Text } from '@/components/priority/Text/Text'

type EditorAccessLostModalProps = {
  show: boolean
  /** Close the prompt and go back to the canvas. */
  onDismiss: () => void
}

/**
 * Shown when a save from an edit-link tab is refused because the tab no
 * longer holds access to the order (`isEditAccessLostError`). It offers no
 * reload: reloading keeps the same link, so it would be refused the same way.
 * Dismiss goes back to the canvas and leaves the unsaved flag alone, so the
 * person can copy text out and Back still asks before leaving.
 */
export const EditorAccessLostModal = ({
  show,
  onDismiss,
}: EditorAccessLostModalProps) => {
  const { t } = useTranslation()
  if (!show) return null

  return (
    <FullscreenModal show={[true, onDismiss]} hideClose={false}>
      <Flex
        column
        full
        padding="32px"
        maxWidth="600px"
        data-testid="editor-access-lost-modal"
      >
        <Text size="20px" weight="600" margin="10px 0 10px 0">
          {t('editor.accessLostModal.title')}
        </Text>
        <Text size="16px" margin="10px 0 10px 0">
          {t('editor.accessLostModal.message')}
        </Text>
        <Text size="16px" weight="500" margin="10px 0 10px 0">
          {t('editor.accessLostModal.reopen')}
        </Text>
        <Flex justify="flex-end" align="center" margin="10px 0 0 0">
          <Button
            primary
            onClick={onDismiss}
            data-testid="editor-access-lost-dismiss"
          >
            {t('editor.accessLostModal.dismiss')}
          </Button>
        </Flex>
      </Flex>
    </FullscreenModal>
  )
}
